import { Component, OnInit, ViewChild } from '@angular/core';
import { IdentityService } from 'src/app/@core/services/identity.service';
import { HomeService } from '../../services/home.service';
import { Partners } from '../../models/partners';
import { LanguageService } from 'src/app/services/language.service';
import { LanguageEnum } from 'src/app/shared/models/item.model';
import { environment } from 'src/environments/environment';
import { CarouselResize } from 'src/app/shared/models/carousel-resize';
import { CustomCarouselComponent } from 'src/app/shared/components/custom-carousel/custom-carousel.component';
import { Status } from 'src/app/@core/enums/status.enum';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})
export class PartnersComponent implements OnInit {
  isRtl: boolean = true;
  mediaUrl: string = environment.mediaUrl;
  carouselResize: CarouselResize<Partners> = {
    data: [],
    items: [],
    itemSizeSm: 1,
    itemSizeMd: 2,
    itemSizeLg: 4,
    itemResize: 0,
    innerWidth: 0,
    currentIndex: 0,
    slideDelay: 5000
  }
  @ViewChild('appCustomCarousel') appCustomCarousel: CustomCarouselComponent<Partners>;
  constructor(private _HomeService:HomeService, private _LanguageService:LanguageService, private _IdentityService: IdentityService){}

  /** Unified Code mode: tokenised layout (styles/unified-code/components/_home.scss). */
  get isUnified(): boolean {
    return this._IdentityService.isUnifiedCode();
  }

  ngOnInit(): void {
    this.isRtl = this._LanguageService.getCurrentLanguage() === LanguageEnum.ar;
    this._LanguageService.languageChange.subscribe((result: LanguageEnum) => this.isRtl = result === LanguageEnum.ar);
    this.getPartners();
  };
  getPartners(): void {
    this._HomeService.getPartners().subscribe({
      next: (data: Partners[]) => this.carouselResize.data = data.filter(c => c.status === Status.Active)
    });
  };
}
